(() => {
  if (globalThis.NswDreamstationPreview?.cartEnabled) return;
  const DEVICE = 44085811118300;
  const BRUSH = 68024359583964;
  const SHAVER = 68024207147228;
  const EPILATOR = 68024110088412;
  const GIFTS = [BRUSH, SHAVER, EPILATOR];
  const start = Date.parse('2026-10-19T09:00:00+11:00');
  const end = Date.parse('2026-12-18T17:00:00+11:00');
  function active(value = Date.now()) {
    const time = typeof value === 'number' ? value : Date.parse(value);
    return Number.isFinite(time) && time >= start && time < end;
  }
  function giftItem(id, quantity) {
    return { id, quantity, properties: { _nsw_dreamstation_gift: 'yes', Promotion: 'Philips Give the Gift of Sleep' } };
  }
  function bundleItems(id, quantity, choice = SHAVER, properties = {}) {
    id = Number(id); quantity = Number(quantity); choice = Number(choice);
    if (id !== DEVICE) throw new Error('This device is not eligible for the Philips gift offer.');
    if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please enter a valid quantity.');
    if (![SHAVER, EPILATOR].includes(choice)) throw new Error('Please select a valid Philips gift.');
    return [
      { id, quantity, properties: { ...properties, _nsw_dreamstation_choice: String(choice), 'Philips gift choice': choice === SHAVER ? 'Shaver' : 'Epilator' } },
      giftItem(BRUSH, quantity), giftItem(choice, quantity)
    ];
  }
  function reconcile(cart, enabled) {
    const wanted = new Map(GIFTS.map(id => [id, 0]));
    if (enabled) for (const item of cart.items) {
      if (Number(item.variant_id) !== DEVICE) continue;
      const choice = Number(item.properties?._nsw_dreamstation_choice) === EPILATOR ? EPILATOR : SHAVER;
      wanted.set(BRUSH, wanted.get(BRUSH) + item.quantity);
      wanted.set(choice, wanted.get(choice) + item.quantity);
    }
    const updates = {}, additions = [];
    for (const id of GIFTS) {
      const lines = cart.items.filter(item => Number(item.variant_id) === id);
      const quantity = wanted.get(id);
      if (!lines.length && quantity) additions.push(giftItem(id, quantity));
      lines.forEach((item, index) => {
        const target = index === 0 ? quantity : 0;
        if (item.quantity !== target) updates[item.key] = target;
      });
    }
    return { updates, additions };
  }
  globalThis.NswDreamstationPreview = Object.freeze({ active, bundleItems, reconcile, cartEnabled: true });
  if (typeof document === 'undefined') return;
  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);
  let operation = Promise.resolve(), timer, adding = false;
  const queue = task => {
    const next = operation.then(task, task);
    operation = next.catch(() => {});
    return next;
  };
  function status(message, error = false) {
    document.querySelectorAll('nsw-dreamstation-gifts [role="status"]').forEach(element => {
      element.textContent = message || element.dataset.default;
      element.classList.toggle('ds-gifts__error', error);
    });
  }
  async function api(path, payload) {
    const response = await originalFetch(root + path, {
      method: payload ? 'POST' : 'GET', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || (typeof data.errors === 'string' ? data.errors : 'Unable to update the Philips gift bundle. Please try again.'));
    return data;
  }
  async function checkGifts(items) {
    const handles = {
      [BRUSH]: 'philips-sonicare-electric-toothbrush',
      [SHAVER]: 'philips-shaver-3000x-series-wet-dry-electric-shaver',
      [EPILATOR]: 'philips-epilator-series-2000'
    };
    await Promise.all(items.filter(item => GIFTS.includes(item.id)).map(async item => {
      const product = await api('products/' + handles[item.id] + '.js');
      const variant = product.variants.find(value => value.id === item.id);
      if (!variant || !variant.available) throw new Error(product.title + ' is currently unavailable for online ordering. Please choose another gift or contact NSW CPAP.');
      if (variant.price !== 0) throw new Error('The Philips gift price needs checking. No bundle has been added. Please contact NSW CPAP.');
    }));
  }
  async function refresh(open = false) {
    const drawer = document.querySelector('cart-drawer');
    const main = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');
    const ids = ['cart-drawer', 'cart-icon-bubble'];
    if (main?.dataset.id) ids.push(main.dataset.id);
    if (footer?.dataset.id) ids.push(footer.dataset.id);
    const response = await originalFetch(root + '?sections=' + ids.join(','), { cache: 'no-store' });
    if (!response.ok) throw new Error('The cart changed but its display could not refresh. Please reload the page.');
    const sections = await response.json();
    const parser = new DOMParser();
    if (drawer && sections['cart-drawer']) {
      const next = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
      const target = drawer.querySelector('#CartDrawer');
      const source = next?.querySelector('#CartDrawer');
      if (target && source) {
        target.innerHTML = source.innerHTML;
        drawer.classList.toggle('is-empty', next.classList.contains('is-empty'));
        drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
        if (open) drawer.open();
      }
    }
    if (sections['cart-icon-bubble']) {
      const next = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      const target = document.getElementById('shopify-section-cart-icon-bubble');
      if (target && next) target.innerHTML = next.innerHTML;
    }
    for (const target of [main, footer]) {
      const html = target && sections[target.dataset.id];
      if (!html) continue;
      const next = parser.parseFromString(html, 'text/html').getElementById(target.id);
      if (next) target.replaceWith(next);
    }
  }
  async function sync() {
    const cart = await api('cart.js');
    const plan = reconcile(cart, active());
    let changed = false;
    if (Object.keys(plan.updates).length) {
      await api('cart/update.js', { updates: plan.updates });
      changed = true;
    }
    if (plan.additions.length) {
      try {
        await checkGifts(plan.additions);
        await api('cart/add.js', { items: plan.additions });
        changed = true;
      } catch (error) {
        if (changed) await refresh();
        throw error;
      }
    }
    if (changed) await refresh();
    return cart;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => queue(sync).catch(error => status(error.message, true)), 200);
  }
  let checkingCheckout = false;
  function checkCheckout(event, control) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingCheckout) return;
    checkingCheckout = true;
    queue(async () => {
      await sync();
      const cart = await api('cart.js');
      const plan = reconcile(cart, active());
      if (Object.keys(plan.updates).length || plan.additions.length) throw new Error('Please wait for the Philips gifts to finish updating before checkout.');
      window.location.assign(root + 'checkout');
    }).catch(error => {
      status(error.message, true);
      const errors = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (errors) { errors.textContent = error.message; errors.setAttribute('role', 'alert'); }
      control?.focus();
    }).finally(() => { checkingCheckout = false; });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest?.('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (control) checkCheckout(event, control);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') checkCheckout(event, event.submitter);
  }, true);
  window.fetch = async function (...args) {
    const response = await originalFetch(...args);
    const request = args[0];
    const url = typeof request === 'string' ? request : request?.url || String(request);
    if (response.ok && /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) schedule();
    return response;
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    const component = [...document.querySelectorAll('nsw-dreamstation-gifts')].find(element => element.dataset.formId === form.getAttribute('id'));
    if (!component || !active()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (adding) return;
    adding = true;
    const button = form.querySelector('[type="submit"]');
    const spinner = button?.querySelector('.loading__spinner');
    button?.setAttribute('aria-disabled', 'true');
    button?.classList.add('loading');
    spinner?.classList.remove('hidden');
    queue(async () => {
      const data = new FormData(form);
      const properties = {};
      for (const [key, value] of data) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      const choice = component.querySelector('input[type="radio"]:checked');
      const items = bundleItems(data.get('id'), Number(data.get('quantity') || 1), choice?.value, properties);
      if (!active()) throw new Error(component.dataset.expired);
      await checkGifts(items);
      const drawer = document.querySelector('cart-drawer');
      drawer?.setActiveElement(document.activeElement);
      status(component.dataset.adding);
      await api('cart/add.js', { items });
      await sync();
      await refresh(true);
      status(component.dataset.added);
      if (!drawer) window.location.assign(root + 'cart');
    }).catch(error => {
      status(error.message, true);
      component.querySelector('[role="status"]')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }).finally(() => {
      adding = false;
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('loading');
      spinner?.classList.add('hidden');
    });
  }, true);
  if (!customElements.get('nsw-dreamstation-gifts')) customElements.define('nsw-dreamstation-gifts', class extends HTMLElement {
    connectedCallback() {
      this.onChange = () => {
        const selected = this.querySelector('input[type="radio"]:checked');
        const label = this.querySelector('[data-gift-name]');
        if (selected && label) label.textContent = selected.dataset.title;
        status();
      };
      this.checkDate = () => {
        if (active()) return;
        this.querySelectorAll('input').forEach(input => { input.disabled = true; });
        this.querySelectorAll('.ds-gifts__choices, .ds-gifts__included, [data-gift-summary]').forEach(element => { element.hidden = true; element.style.display = 'none'; });
        const message = this.querySelector('[role="status"]');
        if (message) message.textContent = this.dataset.expired;
      };
      this.addEventListener('change', this.onChange);
      this.onChange();
      this.checkDate();
      this.timer = setInterval(this.checkDate, 30000);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      clearInterval(this.timer);
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
})();
